export { Event } from 'inscreva-sse-models';
/*
import { StaticImplements, Factory } from './utils';

@StaticImplements<Factory<Event>>()
export class Event extends EventModel {


  static fromJson(event: Partial<Event>) {
    return Object.assign(new EventModel(), event)
  }
}
 */
